var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5834 7.58333C20.5834 6.39166 19.6084 5.41666 18.4167 5.41666H16.2501C15.6542 5.41666 15.1667 5.90416 15.1667 6.5C15.1667 7.09583 15.6542 7.58333 16.2501 7.58333H18.4167V10.4542L14.6467 15.1667H10.8334V10.8333C10.8334 10.2375 10.3459 9.75 9.75008 9.75H6.50008C4.10591 9.75 2.16675 11.6892 2.16675 14.0833V16.25C2.16675 16.8458 2.65425 17.3333 3.25008 17.3333H4.33341C4.33341 19.1317 5.78508 20.5833 7.58341 20.5833C9.38175 20.5833 10.8334 19.1317 10.8334 17.3333H14.6467C15.3076 17.3333 15.9251 17.03 16.3367 16.5208L20.1067 11.8083C20.4209 11.4183 20.5834 10.9417 20.5834 10.4542V7.58333ZM7.58341 18.4167C6.98758 18.4167 6.50008 17.9292 6.50008 17.3333H8.66675C8.66675 17.9292 8.17925 18.4167 7.58341 18.4167Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50008 6.5H9.75008C10.3459 6.5 10.8334 6.9875 10.8334 7.58333C10.8334 8.17917 10.3459 8.66667 9.75008 8.66667H6.50008C5.90425 8.66667 5.41675 8.17917 5.41675 7.58333C5.41675 6.9875 5.90425 6.5 6.50008 6.5ZM20.5834 14.0833C18.7851 14.0833 17.3334 15.535 17.3334 17.3333C17.3334 19.1317 18.7851 20.5833 20.5834 20.5833C22.3817 20.5833 23.8334 19.1317 23.8334 17.3333C23.8334 15.535 22.3817 14.0833 20.5834 14.0833ZM20.5834 18.4167C19.9876 18.4167 19.5001 17.9292 19.5001 17.3333C19.5001 16.7375 19.9876 16.25 20.5834 16.25C21.1792 16.25 21.6667 16.7375 21.6667 17.3333C21.6667 17.9292 21.1792 18.4167 20.5834 18.4167Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiders);
export default __webpack_public_path__ + "static/media/riders.a388ac73.svg";
export { ForwardRef as ReactComponent };